import { useTranslations } from 'next-intl';

export function formatDuration(seconds?: number): string {
  if (!seconds || seconds < 0) {
    return '00:00:00';
  }
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  const hh = h.toString().padStart(2, '0');
  const mm = m.toString().padStart(2, '0');
  const ss = s.toString().padStart(2, '0');

  return `${hh}:${mm}:${ss}`;
}

export function useFormattedDuration() {
  const t = useTranslations();

  return (seconds?: number) => {
    if (!seconds || seconds < 0) {
      return `0 ${t('sekund')}`;
    }
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    if (h > 0 && m > 0) return `${h} ${t('soat')} ${m} ${t('minut')}`;
    if (h > 0) return `${h} ${t('soat')}`;
    if (m > 0 && s > 0) return `${m} ${t('minut')} ${s} ${t('sekund')}`;
    if (m > 0) return `${m} ${t('minut')}`;
    return `${s} ${t('sekund')}`;
  };
}
